import { useRouteError } from "react-router-dom";
import { AlertTriangle, RefreshCw, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { hardReload, isChunkError } from "@/lib/lazyRetry";

const Card = ({ icon: Icon, title, text, children, testId }) => (
  <div className="flex min-h-[60vh] items-center justify-center p-6" data-testid={testId}>
    <div className="w-full max-w-md space-y-4 rounded-md border bg-card p-6 shadow-sm">
      <div className="flex items-center gap-2"><Icon className="h-5 w-5 text-primary" /><h1 className="text-lg font-semibold">{title}</h1></div>
      <p className="text-sm text-muted-foreground">{text}</p>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  </div>
);

// Router errorElement: friendly cards, never a raw stack trace in production.
export const RouteError = () => {
  const err = useRouteError();
  if (isChunkError(err)) {
    return (
      <Card icon={Sparkles} title="A new version of the app is available" testId="route-error-new-version"
        text="This page was updated since you opened the app. Reload to get the latest version – your drafts are saved.">
        <Button onClick={hardReload} data-testid="route-error-reload"><RefreshCw className="mr-2 h-4 w-4" />Reload</Button>
      </Card>
    );
  }
  return (
    <Card icon={AlertTriangle} title="Something went wrong" testId="route-error-generic"
      text={process.env.NODE_ENV === "production" ? "This page couldn't be shown. Reload to try again, or go back to the Cockpit." : String(err?.message || err)}>
      <Button onClick={hardReload} data-testid="route-error-reload"><RefreshCw className="mr-2 h-4 w-4" />Reload</Button>
      <Button variant="outline" onClick={() => window.location.assign("/cockpit")} data-testid="route-error-cockpit">Go to Cockpit</Button>
    </Card>
  );
};
